<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#000" d="M4 12h16M11.5 19L4 12l7.5-7" stroke-width="1.5" />
</svg>
